import React from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import CardMedia from '@material-ui/core/CardMedia';
import Dialog from '@afosto/app-components-react/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import resizeImageUrl from '@afosto/utils/resizeImageUrl';
import translations from './translations';

const ProductDialog = ({ isOpen, onClose, onExited, product }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  return (
    <Dialog fullScreen={isMobile} open={isOpen} onClose={onClose} onExited={onExited} fullWidth>
      {product?.image && (
        <CardMedia
          alt={product?.name}
          image={resizeImageUrl(product?.image, 400)}
          title={product?.name}
          style={{
            width: 'auto',
            paddingTop: '100%',
          }}
        />
      )}
      <DialogTitle>{product?.name ?? ''}</DialogTitle>
      <DialogContent style={{ minWidth: 350 }}>
        <div>
          <FormattedMessage
            {...translations.properties.articleNumber}
            values={{ number: product?.sku }}
          />
        </div>
        <div>
          <FormattedMessage
            {...translations.properties.eanNumber}
            values={{ number: product?.ean }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button type="button" variant="contained" color="primary" onClick={onClose}>
          <FormattedMessage {...translations.actions.close} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ProductDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onExited: PropTypes.func,
  product: PropTypes.object,
};

ProductDialog.defaultProps = {
  isOpen: false,
  onClose: undefined,
  onExited: undefined,
  product: {},
};

export default ProductDialog;
